import { Record, List } from 'immutable';

import { resolve, resolveAll } from '../helpers/LinkMapper';
import StationStop from './StationStop';
import ServiceDetails from './ServiceDetails';
import { TransitModes } from '../constants/AppConstants';

const Leg = new Record({
    id: null,
    origin: new List(),
    destination: new List(),
    serviceDetails: new ServiceDetails(),
    transferTime: 0
});

Leg.fromJSON = function (json) {
    json = json || {};

    const id = json.id;

    // Some services may have multiple origins/destinations
    // e.g Trains joining together or breaking apart at certain points
    const origin = resolveAll(json.origin).as(StationStop);
    const destination = resolveAll(json.destination).as(StationStop);

    const serviceDetails = resolve(json.serviceDetails).as(ServiceDetails);
    const transferTime = resolve(json.transferTime || 0).with(Number);

    let result = { id, origin, destination, serviceDetails, transferTime };

    return new Leg(result);
};

Object.assign(Leg.prototype, {
    getOriginStation () {
        return this.origin.first().station;
    },

    getDestinationStation () {
        return this.destination.first().station;
    },

    getDepartureTime () {
        return this.origin.first().getIn(['time', 'scheduledTime']);
    },

    getArrivalTime () {
        return this.destination.first().getIn(['time', 'scheduledTime']);
    },

    getTrainUid () {
        return this.serviceDetails.trainUid;
    },

    getIsMetro () {
        return this.serviceDetails.mode === TransitModes.METRO;
    }
});

export default Leg;



// WEBPACK FOOTER //
// ./src/records/Leg.js